<template>
  <v-container fluid class="add-field fill-height">
    <v-layout class="div-center-horizontally">
      <v-flex xs12 sm12>
        <v-container class="medium-div">
          <v-layout row class="header-row">
            <v-flex class="div-center-vertically">
              <p class="org-name">{{organization}}</p>
            </v-flex>
            <v-flex class="div-center-vertically div-right-horizontally">
              <v-btn icon @click="close">
                <v-icon class="close-icon">close</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout row class="field-content-row">
            <v-flex xs12>
              <FieldEditor :isNewField="isNewField" :fieldData.sync="fieldData" :comesFromAnotherRoute="comesFromAnotherRoute" :comesFromAnotherRouteData="comesFromAnotherRouteData" :comesFromAnotherRouteName="comesFromAnotherRouteName" />
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import FieldEditor from './AddField/FieldEditor'

export default {
  components: {
    FieldEditor
  },
  data () {
    return {
      organization: this.$store.getters.userOrganization.name,
      fieldData: {
        id: this.$route.params.field && this.$route.params.field.id ? this.$route.params.field.id : '',
        name: this.$route.params.field && this.$route.params.field.name ? this.$route.params.field.name : '',
        contact: this.$route.params.field && this.$route.params.field.contact ? this.$route.params.field.contact : '',
        auxContact: this.$route.params.field && this.$route.params.field.auxContact ? this.$route.params.field.auxContact : '',
        gates: this.$route.params.field && this.$route.params.field.gates ? this.$route.params.field.gates : [],
        crops: this.$route.params.field && this.$route.params.field.crops ? this.$route.params.field.crops : []
      },
      comesFromAnotherRoute: this.$route.params.comesFromAnotherRoute || false,
      comesFromAnotherRouteData: this.$route.params.comesFromAnotherRouteData || {},
      comesFromAnotherRouteName: this.$route.params.comesFromAnotherRouteName || 'AddCrop',
      isNewField: this.$route.params.isNewField
    }
  },
  methods: {
    getUserName (id) {
      if (id) {
        const user = this.$store.getters.organizationUsers.find(elem => elem.id === id)
        return `${user.name} ${user.lastName}`
      }
      return ''
    },
    close () {
      if (this.comesFromAnotherRoute) {
        this.$router.push({name: this.comesFromAnotherRouteName,
          params: {
            comesFromAnotherRoute: true,
            comesFromAnotherRouteData: this.comesFromAnotherRouteData
          }
        })
      } else {
        this.$router.push({ name: 'OrganizationHome' })
      }
    }
  },
  computed: {
    gates () {
      return this.fieldData.gates
    }
  }
}
</script>



// WEBPACK FOOTER //
// AddField.vue?01c24efe